import {Directive, ElementRef} from '@angular/core';
import { NgModel } from '@angular/forms';
import * as $ from 'jquery';
import {NgbDatepicker} from "@ng-bootstrap/ng-bootstrap";
import { MIN_YEAR, MAX_YEAR } from '../constants/application.constants';


const INVALID_DATE = "Invalid Date.";

@Directive({
  selector: "input[ngModel][ngbDatepicker]",
  providers: [NgModel,NgbDatepicker]
})

export class DateValidationDirective {

  constructor(private elem: ElementRef, private ngModel: NgModel) {
  }

  ngAfterViewInit() {
    let that = this;
    that.elem.nativeElement.addEventListener('blur', that.validateDate);
    that.elem.nativeElement.addEventListener('keydown', that.toggleNgbDatePickerKeyboard);
  }

  validateDate(event){
    let elem: any = this || event;
    const date = elem.inputmask.unmaskedvalue();
    // Length of months (will update for leap years)
    const monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
    let errorMsgID = elem.id + '_errorMsgInvalidDt';
    let errorMsg = INVALID_DATE;

    $("#"+errorMsgID).remove();

    if(!elem.inputmask.isComplete() || date === "" ){
      return;
    }

    // Parse the date input to integers
    const month = parseInt(date.substring(0,2), 10);
    const day = parseInt(date.substring(2,4), 10);
    const year = parseInt(date.substring(4), 10);

    // Make sure date is in range
    if (year < MIN_YEAR || year > MAX_YEAR || month === 0 || month > 12) {
      $(elem).parent().parent(":not(:has([id*='_errorMsg']))").append("<div id='" + errorMsgID + "' role='alert'><small class='form-text text-danger'>"+errorMsg+"</small></div>");
    }
    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
      monthLength[1] = 29;
    }
    // Check the range of the day
    if (!(day > 0 && day <= monthLength[month - 1])) {
      $(elem).parent().parent(":not(:has([id*='_errorMsg']))").append("<div id='" + errorMsgID + "' role='alert'><small class='form-text text-danger'>"+errorMsg+"</small></div>");
    };

    return;
  }

  toggleNgbDatePickerKeyboard(event: KeyboardEvent){
    const KEY_DOWN = 40;
    var datePickerElement = (<HTMLInputElement>event.target);
    if(event.altKey){
      if(event.keyCode === KEY_DOWN){
        datePickerElement.click();
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/dateValidation.directive.ts